import Link from 'next/link';
import React from 'react';
import styled from 'styled-components';


export default function WhiteBackground(){
  return <Container>
    <div className="maxwidth">
      <Menu>
        {/*<Link href="/text/document?type=policy">Политика конфиденциальности</Link>*/}
        <Link href="/text/document?type=agreemet">Пользовательское соглашение</Link>
      </Menu>

      <div>420054, г. Казань, ул.Тихорецкая, д.11, к.2 © {new Date().getFullYear()}.</div>
    </div>
  </Container>
}

const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;

  height: 45px;
  border-bottom: 1px solid #eee;

  & > div {
    justify-content: space-between;
    display: flex;
    align-items: center;
  }

  @media (max-width: 700px) {
    height: initial;
    padding: 20px 0;

    & > div {
      display: grid;
      grid-template-columns: 100%;
      grid-row-gap: 20px;
    }
  }

  @media (max-width: 480px) {
    /* height: initial;
    padding: 20px 0px; */
    /* &>div{
      display: grid;
      grid-template-columns: 100%;
      grid-row-gap: 20px;
    } */
  }
`

const Menu = styled.div`
  & a {
    margin-right: 20px;
  }

  @media (max-width: 480px) {
    display: grid;
    grid-template-columns: 100%;
    grid-row-gap: 20px;
  }
`